import { editTemplatePublic } from '@/pages/api/scribeAPIV2';
import { type EditTemplatePublicResponse } from '@heidi/templates/contracts';
import { useMutation } from '@tanstack/react-query';

export const PUBLIC_TEMPLATE_EDIT_MUTATION_KEY = ['public-template-edit'] as const;

interface PublicTemplateEditParams {
  existingTemplate: string;
  editRequest: string;
  specialtyName?: string;
  country?: string;
  language?: string;
}

export function useMutationPublicTemplateEdit() {
  return useMutation<EditTemplatePublicResponse, Error, PublicTemplateEditParams>({
    mutationKey: PUBLIC_TEMPLATE_EDIT_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async ({
      existingTemplate,
      editRequest,
      specialtyName,
      country,
      language,
    }) => {
      const { data } = await editTemplatePublic({
        existing_template: existingTemplate,
        edit_request: editRequest,
        specialty_name: specialtyName,
        country,
        language,
      });
      return data;
    },
  });
}
